var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 19.5V20.5H3V19.5L5 17.5V11.5C5 8.4 7.03 5.67 10 4.79C10 4.69 10 4.6 10 4.5C10 3.96957 10.2107 3.46086 10.5858 3.08579C10.9609 2.71071 11.4696 2.5 12 2.5C12.5304 2.5 13.0391 2.71071 13.4142 3.08579C13.7893 3.46086 14 3.96957 14 4.5C14 4.6 14 4.69 14 4.79C16.97 5.67 19 8.4 19 11.5V17.5L21 19.5ZM14 21.5C14 22.0304 13.7893 22.5391 13.4142 22.9142C13.0391 23.2893 12.5304 23.5 12 23.5C11.4696 23.5 10.9609 23.2893 10.5858 22.9142C10.2107 22.5391 10 22.0304 10 21.5",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.3146c988be5f30ef52771dec7a0e605c.svg";
export { ForwardRef as ReactComponent };